/* eslint-disable @typescript-eslint/no-explicit-any */
import { ReactElement } from "react";

/**
 * Retrieves the header elements based on the provided data and map.
 * @param data - The data object containing key-value pairs.
 * @param map - The map object containing key-reactNode pairs.
 * @returns An array of React elements representing the header.
 */
export const getHeader = ({
  data,
  map,
}: {
  data: Record<string, string | number | null | undefined>;
  map: Record<string, React.ReactNode>;
}) => {
  if (!data || !map) return [];
  return Object.keys(data).map((key) => map[key]);
};

export type ElementGetter = (value: any) => ReactElement;

/**
 * Retrieves the rows based on the provided data and elementMap.
 * @param data - The data array containing objects with key-value pairs.
 * @param elementMap - The elementMap object containing key-value pairs where the key represents the data key and the value is a function that returns a React element.
 * @returns An array of arrays representing the rows.
 */
export const getRows = ({
  data,
  tableCellMap,
}: {
  data: Record<string, string | number | null | undefined>[];
  tableCellMap: Record<string, ElementGetter>;
}) => {
  if (!data.length || !tableCellMap) return [];
  return data.map((row) =>
    Object.entries(row).map(([key, value]) => {
      if (value == null) {
        return "-";
      }
      if (key in tableCellMap) {
        const getElement = tableCellMap[key];
        return getElement(value);
      }
      return value;
    })
  );
};
